const SitePermissionTypes = {
  G: 'Grant',
};

export default SitePermissionTypes;
